export default "__VITE_ASSET__CD5nN$Jf__"